/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_FinalizedInputs */

const en_cases_filter_finalized = /** @type {(inputs: Cases_Filter_FinalizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalized`)
};

const pt_br2_cases_filter_finalized = /** @type {(inputs: Cases_Filter_FinalizedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finalizado`)
};

/**
* | output |
* | --- |
* | "Finalized" |
*
* @param {Cases_Filter_FinalizedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_finalized = /** @type {((inputs?: Cases_Filter_FinalizedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_FinalizedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_finalized(inputs)
	return pt_br2_cases_filter_finalized(inputs)
});